import { CommentStatus } from '@app/entities/enums/comment/comment.enum';

export class Comment {
  id!: number;
  user_id!: string;
  name!: string;
  lastname!: string;
  department!: string;
  comment!: string;
  creation_date!: string;
  response_comments?: Comment[];
  status!: CommentStatus;
  photo!: string;
  cod_store?: string;
  store?: string;
  language?: string;
  division_zone!: string;
  role?: string;
  show_info?: boolean;
  parent_id?: number;
  highlighted?: boolean;
  translationKey!: string;
}

export class CommentsPaginated {
  comments!: Comment[];
  commentsCount!: number;
  commentsByPage!: number;
  totalPages!: number;
}
